import React, { useCallback, useEffect, useState } from 'react';
import DriverSelect from './DriverSelect';
import PolicyChange from '../PolicyChange';
import Form from '../FormDisplay';
import ChangedFields from '../ChangedFields';
import Conclusion from '../Conclusion';

const DeleteDriver = ({ setLoading, actions, onError, policy, onCancel, effectiveDate, onComplete, onSave, onExit, save, rate, setRate }) => {
	const [driver, setDriver] = useState(null);
	const [isComplete, setIsComplete] = useState(false);

	useEffect(() => {
		if (save && save.originalDriver) {
			setDriver(save.originalDriver);
		}
	}, [save]);

	const _onSaveAndExit = useCallback(async () => {
		await onSave({ originalDriver: driver }, rate);
		onExit();
	}, [driver, onExit, onSave, rate]);

	const onRate = useCallback(
		async (selectedDriver) => {
			try {
				setDriver(selectedDriver);
				setLoading('Generating rate');
				var result = await actions.rateDeleteDriver({ policyId: policy.policyId, policyNumber: policy.policyNumber, effectiveDate, driverNum: selectedDriver.driverNum });

				const _rate = { ...result.response, email: { action: 'Deleted', name: `${selectedDriver.firstName} ${selectedDriver.lastName}` } };

				setRate(_rate);
				await onSave({ originalDriver: selectedDriver }, _rate);

				setLoading(null);
			} catch (error) {
				setDriver(null);
				onError(error.error);
				setLoading(null);
			}
		},
		[actions, effectiveDate, onError, onSave, policy, setLoading, setRate]
	);

	const onRateConfirm = useCallback(() => {
		onComplete(rate);
		setIsComplete(true);
	}, [onComplete, rate]);

	if (!driver) {
		return <DriverSelect policy={policy} onDriverSelect={onRate} onCancel={onCancel} confirmMessage='Are you sure you want to delete this driver?' message="Please select the driver you'd like to delete" isDelete effectiveDate={effectiveDate} />;
	}

	if (!isComplete) {
		return (
			<PolicyChange policy={policy} name='Driver' title='Please review and complete deleting a driver' onSaveAndExit={_onSaveAndExit} onComplete={onRateConfirm} rate={rate} onCancel={onCancel}>
				<Form>
					<Form.Display label='Deleted Driver' inline value={`${driver.firstName} ${driver.lastName}`} />
				</Form>
			</PolicyChange>
		);
	} else {
		return (
			<Conclusion title='The deletion of the following driver was completed successfully!' rate={rate} policy={policy} onExit={onExit}>
				<ChangedFields
					other={[
						{ label: 'Deleted Driver', text: `${driver.firstName} ${driver.lastName}` }
					]}
				/>
			</Conclusion>
		);
	}
};

DeleteDriver.propTypes = {};

export default DeleteDriver;
